import { defineComponent, ref } from "vue";
import { showLoadingToast, closeToast, showNotify } from "vant";
import { useRouter } from "vue-router";
import { mobileHide } from "@/utils/index";
import { getStudent, switchBind } from "@/api/login";
export default defineComponent({
  name: "SwitchBind",
  setup() {
    const router = useRouter();
    const userList = ref();
    const getInfo = () => {
      showLoadingToast({
        message: "加载中...",
        forbidClick: true
      });
      getStudent().then(({
        data
      }) => {
        userList.value = data;
      }).finally(() => {
        closeToast();
      });
    };
    getInfo();
    console.log(router);
    const userSwitch = ({
      companyId,
      personId
    }, index) => {
      if (index === 0) return;
      showLoadingToast({
        message: "切换中...",
        forbidClick: true
      });
      switchBind({
        companyId,
        personId
      }).then(({
        code,
        msg
      }) => {
        if (code === 200) {
          showNotify({
            type: "success",
            message: msg
          });
          // router.push("/my");
          getInfo();
        }
      }).finally(() => {
        closeToast();
      });
    };
    return {
      mobileHide,
      userList,
      userSwitch
    };
  }
});